import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, effect, input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { CountDown, INIT_COUNT } from "../codere-countdown/codere-countdown.component";

export interface CountDownOptions {
  d: boolean;
  h: boolean;
  m: boolean;
  s: boolean;
}

enum DateCards {
  d = "days",
  h = "hours",
  m = "minutes",
  s = "seconds",
}

const LITERALES: { [key: string]: string } = {
  [DateCards.d]: "days",
  [DateCards.h]: "hours",
  [DateCards.m]: "minutes",
  [DateCards.s]: "Segundos",
};

@Component({
  selector: "codere-countdown-banner-template",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: "./codere-countdown-banner-template.component.html",
  styleUrls: ["./codere-countdown-banner-template.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CodereCountdownBannerTemplateComponent {
  countDownResult = input.required<CountDown>();
  countDownOptions = input<CountDownOptions>({ d: true, h: true, m: true, s: true });
  dataToShow: { keyResult: keyof CountDown; literal: string }[] = [];
  limitString = INIT_COUNT.seconds;

  constructor() {
    effect(() => {
      this.dataToShow = [];
      for (const key in this.countDownOptions()) {
        if (this.countDownOptions()[key]) {
          const keyResult = DateCards[key];
          this.dataToShow.push({ keyResult, literal: this.getLiteral(keyResult) });
        }
      }
    });
  }

  getLiteral(card: DateCards) {
    return LITERALES[card];
  }
}
